/**
 * Arabic-Indic (U+0660–U+0669) and Persian (U+06F0–U+06F9) digits → ASCII 0–9
 * so bill_id sorts numerically when the DB stores localized numerals.
 */
export function normalizeBillIdDigits(value) {
  let out = "";
  for (const ch of String(value ?? "")) {
    const cp = ch.codePointAt(0);
    if (cp >= 0x0660 && cp <= 0x0669) {
      out += String.fromCharCode(cp - 0x0660 + 0x30);
    } else if (cp >= 0x06f0 && cp <= 0x06f9) {
      out += String.fromCharCode(cp - 0x06f0 + 0x30);
    } else {
      out += ch;
    }
  }
  return out;
}

export function parseBillIdAsInt(value) {
  const n = parseInt(normalizeBillIdDigits(value).trim(), 10);
  return Number.isNaN(n) ? NaN : n;
}
